export const QA_NAME_APPLICANT_MATCHING_WIDGET = 'applicantMatching'

export const QA_NAME_APPLICANT_MATCHING_DISCARD = 'applicantMatchingDiscard'

export const APPLICANT_MATCHING_FIELD_NAME_HOUSEHOLD_SIZE = 'household_size'

export const APPLICANT_MATCHING_FIELD_NAME_MOVE_IN_DATE = 'move_in_date'

export const APPLICANT_MATCHING_ROW = {
  householdSize: 'household_size',
  moveInDate: 'move_in_date',
}

export const APPLICANT_MATCHING_DISCARD_CONFIRMATION_PROPS = {
  description: 'RentalPortal.ApplicantProfileMatchingDiscardTextKey',
  qaName: QA_NAME_APPLICANT_MATCHING_DISCARD,
  title: 'RentalPortal.ListingProfileBlockDiscardTitleKey',
}
